import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const StorePickupShippingCompanies = (params?: any) =>
    request({
        url: ApiURL.Query.StorePickupShippingCompanies,
        method: RequestType.GET,
        params,
    });

const GetStorePickupPackageList = (params: any) => {
    let url = ApiURL.Query.GetStorePickupPackageList + '?StoreCode=' + params.storeCode;

    if (params.dPackageCargoShipmentCode) {
        url += '&ShippingCompanyId=0';
        url += '&DPackageCargoShipmentCode=' + encodeURIComponent(params.dPackageCargoShipmentCode);
    } else if (params.shippingCompanyId && params.shippingCompanyId !== 'all') {
        url += '&ShippingCompanyId=' + params.shippingCompanyId;
    }

    return request({
        url: url,
        method: RequestType.GET,
    });
};

const StorePickupPackageQuery = {
    StorePickupShippingCompanies,
    GetStorePickupPackageList,
};

export default StorePickupPackageQuery;
